module.exports = __webpack_public_path__ + "img/Otium-logo-white-horizontal.a074ad1b.png";